import MainNavBar2 from "../../components/Main_Interface/MainNavBar/MainNavBar2";
import ProductDetailBread from "../../components/Main_Interface/BreadCrumbs/ProductDetailBread";
import ProductDetailHead from "../../components/Main_Interface/Cards/ProductDetailHead";
import ProductDetailTab from "../../components/Main_Interface/Tab/productDetailTab";
import MainFooter from "../../components/Main_Interface/Footer/Footer";
import MainFloatingButton from "../../components/Main_Interface/Footer/MainFloatingButton";
import Loader from "../../components/CMS/Loader/Loader";


import React, { useState, useEffect } from "react";

export default function ProductDetail(){
    const queryParams = new URLSearchParams(window.location.search);
    const projectId = queryParams.get('projectId');
    
    const [projectDetail, setProjectDetail] = useState(null);
    const [imgUrls, setImageUrls] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if(projectId === null){
            window.location.href = '/PageNotFound';
        }
        getProjectDesc(projectId);
        getProjectImages(projectId);
        localStorage.setItem("form_project_detail", true)
    }, []);

    function getProjectDesc(currentProjectId) {
        var apiLink = process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/projects/'+currentProjectId;
        fetch(apiLink)
            .then(response => response.json())
            .then((usefulData) => {
                if(usefulData.data == null){
                    window.location.href = '/PageNotFound';
                }
                setProjectDetail(usefulData.data);
                setLoading(false);
            })
            .catch((e) => {
                console.error(`An error occurred: ${e}`)
            });
    }

    function getProjectImages(currentProjectId) {
        var apiLink = process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/projects/'+ currentProjectId +'/img';
        fetch(apiLink)
            .then(response => response.json())
            .then((usefulData) => {
                setImageUrls(usefulData.data.projectImgUrls)
            })
            .catch((e) => {
                console.error(`An error occurred: ${e}`)
            });
    }

    return(
        <>
            <MainNavBar2 currentPage={"productList"}></MainNavBar2>
            {
                (loading === true)
                    ? <Loader></Loader>
                    : <>
                        <ProductDetailHead projectDetail={projectDetail}></ProductDetailHead>
                        <ProductDetailTab imgUrls={imgUrls}></ProductDetailTab>
                    </>
            }
            <MainFloatingButton></MainFloatingButton>
            <MainFooter></MainFooter>
        </>
    );
}